import styled from "styled-components";
import { Menu as AntdMenu, Flex } from "antd";
import { Link } from "react-router-dom";

export const LogoLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 46px;
  padding: 10px 16px;

  @media (min-width: 576px) {
    height: 104px;
    padding: 28px 40px;
  }
`;

export const Container = styled(Flex)`
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const Content = styled.nav`
  flex: 1 1 auto;
  padding-bottom: 16px;
`;

export const Footer = styled.footer`
  width: 100%;
  text-align: center;
  flex: 0 0 auto;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.token.colorTextLabel};
  font-size: 0.85em;
  margin-bottom: 4px;

  :hover {
    color: ${({ theme }) => theme.token.colorPrimary};
  }
`;

export const Menu = styled(AntdMenu)`
  .ant-menu-item-group {
    .ant-menu-item-group-title {
      font-weight: bold;
      display: none;

      @media (min-width: 576px) {
        display: inherit;
      }
    }

    .ant-menu-item {
      @media (min-width: 576px) {
        height: auto;
        min-height: 40px;
        white-space: normal;
        line-height: 20px;
        padding-top: 4px;
        padding-bottom: 4px;
      }
    }
  }

  .ant-menu-item-divider {
    border-color: #cbd0dd;
    border-width: 1px 0 0;

    &:first-child {
      margin-top: 0;
    }
  }
`;
